import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import ProfileLayout from '../../components/ProfileLayout';
import ProfileContent from '../../components/ProfileContent';

// Заглушка для аватара игры
const gameImageUrl = '/images/hero-auth.jpg';

// Валидация email
const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const ProfilePage = () => {
  const { user, updateProfile, uploadAvatar, error, clearError } = useAuth();
  
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [newName, setNewName] = useState(user?.first_name || '');
  const [newEmail, setNewEmail] = useState(user?.email || '');
  const [emailError, setEmailError] = useState(null);
  const [updateMessage, setUpdateMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleEditName = () => {
    // Закрываем редактирование email если открыто
    setIsEditingEmail(false);
    setNewEmail(user?.email || '');
    
    setNewName(user?.first_name || '');
    setIsEditingName(true);
    setUpdateMessage(null);
    clearError();
  };

  const handleEditEmail = () => {
    // Закрываем редактирование имени если открыто
    setIsEditingName(false);
    setNewName(user?.first_name || '');
    
    setNewEmail(user?.email || '');
    setIsEditingEmail(true);
    setUpdateMessage(null);
    clearError();
  };

  const handleSaveName = async () => {
    if (!newName.trim()) return;
    
    setLoading(true);
    const result = await updateProfile({ first_name: newName.trim() });
    setLoading(false);
    
    if (result.success) {
      setIsEditingName(false);
      setUpdateMessage('Имя успешно обновлено');
    }
  };

  const handleSaveEmail = async () => {
    if (!newEmail.trim()) return;
    
    // Валидация email
    if (!isValidEmail(newEmail.trim())) {
      setEmailError('Введите корректный email адрес');
      return;
    }
    
    setEmailError(null);
    setLoading(true);
    const result = await updateProfile({ email: newEmail.trim() });
    setLoading(false);
    
    if (result.success) {
      setIsEditingEmail(false);
      setUpdateMessage('На новый email отправлено письмо для подтверждения');
    }
  };

  const handleEmailChange = (value) => {
    setNewEmail(value);
    // Очищаем ошибку при изменении
    if (emailError) {
      setEmailError(null);
    }
  };

  const handleCancelEdit = () => {
    setIsEditingName(false);
    setIsEditingEmail(false);
    setNewName(user?.first_name || '');
    setNewEmail(user?.email || '');
    clearError();
  };

  const handleUploadAvatar = async (file) => {
    await uploadAvatar(file);
  };

  return (
    <ProfileLayout>
      <ProfileContent
        gameName={user?.first_name || 'Пользователь'}
        gameImage={user?.photo || gameImageUrl}
        userName={user?.first_name || 'Пользователь'}
        userEmail={user?.email || ''}
        onEditName={handleEditName}
        onEditEmail={handleEditEmail}
        onUploadAvatar={handleUploadAvatar}
        // Edit mode props
        isEditingName={isEditingName}
        isEditingEmail={isEditingEmail}
        newName={newName}
        newEmail={newEmail}
        onNameChange={setNewName}
        onEmailChange={handleEmailChange}
        onSaveName={handleSaveName}
        onSaveEmail={handleSaveEmail}
        onCancelEdit={handleCancelEdit}
        loading={loading}
        error={error || emailError}
        successMessage={updateMessage}
      />
    </ProfileLayout>
  );
};

export default ProfilePage;
